import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ReportDocument } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends TmsWebBaseEditService<ReportDocument, ReportDocument> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('Document', $localize`Document`);
  }

  getDocument(documentName: string): Observable<ReportDocument> {
    return this.httpService.get<ReportDocument>(`${this.apiUrl}/GetDocument?documentName=${documentName}`);
  }

  getAllExternalDocuments(): Observable<ReportDocument[]> {
    return this.httpService.get<ReportDocument[]>(`${this.apiUrl}/GetAllExternalDocuments`);
  }
}
